import styled from 'styled-components'

export const StyledInput = styled.input`
  border: none;
  background: transparent;
  padding: 0;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  color: #4d5874;

  &:focus {
    outline: none;
    color: #4d5874;
  }

  &::placeholder {
    color: #4d5874;
    opacity: 0.6;
  }

  &:disabled {
    color: #4d5874;
  }

  &:not(:disabled):hover {
    color: black;
  }
`
